module.exports = __webpack_public_path__ + "static/img/merit1.26b9bcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/merit1.png
// module id = p2pR
// module chunks = 2